export default __webpack_public_path__ + "static/media/setting.c012e74d.svg";